import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { pageSamples } from '../data/content';
export function InsidePages() {
  const [index, setIndex] = useState<number>(0);
  const [direction, setDirection] = useState<number>(1);
  const total = pageSamples.length;
  const current = pageSamples[index];
  const go = (next: number) => {
    setDirection(next > index ? 1 : -1);
    setIndex((next + total) % total);
  };
  return <section id="inside-pages" className="w-full overflow-x-hidden bg-cream px-5 py-20 sm:py-28" data-id="element-130" data-mp="31xnaxe76rbgu">
      <div className="mx-auto max-w-5xl" data-id="element-131" data-mp="2x4axm07yir3e">
        <div className="mx-auto max-w-2xl text-center" data-id="element-132" data-mp="2s6soa8q129uv">
          <span className="text-[11px] font-bold uppercase tracking-[0.18em] text-brand" data-id="element-133" data-mp="2s69c78n26for">
            Zajrzyj do środka
          </span>
          <h2 className="mt-5 font-display text-[1.8rem] font-black leading-tight tracking-tight text-ink sm:text-[2.6rem]" data-id="element-134" data-mp="3kvgdgfdwdjdp">
            Zobacz materiały <span className="italic text-brand" data-id="element-135" data-mp="1mne0a1t3ih81">od środka.</span>
          </h2>
          <p className="mt-4 text-sm leading-relaxed text-ink/60 sm:text-base" data-id="element-136" data-mp="1rlz0w2c9f2x0">
            Prawdziwe strony z pakietu — od ćwiczeń o rytmie dla klasy 4 po karty
            historii muzyki i krzyżówki powtórkowe.
          </p>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-8 rounded-3xl outline-none focus-visible:ring-4 focus-visible:ring-brand/20 md:mt-12 md:grid-cols-[minmax(0,1fr)_17rem] md:items-center" role="group" aria-roledescription="karuzela" aria-label="Przykładowe strony materiałów" tabIndex={0} onKeyDown={event => {
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          go(index + 1);
        }
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          go(index - 1);
        }
      }} data-id="element-137" data-mp="1htt8iri3ijha">
          <div className="relative min-w-0" data-id="element-138" data-mp="623kxwb9ydtv">
            <div className="flex h-[22rem] items-center justify-center overflow-hidden rounded-3xl bg-white p-3 shadow-soft sm:h-[30rem] sm:p-6" data-id="element-139" data-mp="63wvhmp0di75">
              <AnimatePresence initial={false} mode="wait" data-id="element-140" data-mp="3t6rug6z6jqee">
                <motion.img key={current.src} src={current.src} alt={`${current.title} — przykładowa strona, ${current.level}`} initial={{
                opacity: 0,
                x: direction * 32
              }} animate={{
                opacity: 1,
                x: 0
              }} exit={{
                opacity: 0,
                x: direction * -32
              }} transition={{
                duration: 0.25,
                ease: [0.23, 1, 0.32, 1]
              }} className="h-full w-full object-contain" data-id="element-141" data-mp="3t7bebt8e4ov2" />
              </AnimatePresence>
            </div>

            <button type="button" onClick={() => go(index - 1)} aria-label="Poprzednia strona" className="absolute left-2 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-brand text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:bg-brand-dark active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:left-3 sm:h-14 sm:w-14" data-id="element-142" data-mp="18h2hjzi1eeoc">
              <ChevronLeftIcon className="h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-143" data-mp="1p2l1gilta6qs" />
            </button>
            <button type="button" onClick={() => go(index + 1)} aria-label="Następna strona" className="absolute right-2 top-1/2 inline-flex h-11 w-11 -translate-y-1/2 items-center justify-center rounded-full border-2 border-white bg-brand text-white shadow-soft transition-[transform,background-color] duration-150 ease-out hover:bg-brand-dark active:scale-95 focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:right-3 sm:h-14 sm:w-14" data-id="element-144" data-mp="1yyxvjhl9qmm2">
              <ChevronRightIcon className="h-6 w-6 sm:h-7 sm:w-7" aria-hidden="true" data-id="element-145" data-mp="241wzoci0hgo6" />
            </button>
          </div>

          <div className="flex min-w-0 flex-col" data-id="element-146" data-mp="2dsi8esreg1kt">
            <p className="text-[10px] font-bold uppercase tracking-[0.16em] text-brand" data-id="element-147" data-mp="2ds9uqyngcs8k">
              {current.level}
            </p>
            <h3 className="mt-2 font-display text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-148" data-mp="1l447o58xer5k">
              {current.title}
            </h3>
            <p className="mt-3 text-sm leading-relaxed text-ink/60" data-id="element-149" data-mp="1h3kbb3w6frkh">
              {current.caption}
            </p>
            <p className="mt-4 text-xs font-bold tabular-nums text-ink/40" data-id="element-150" data-mp="1v3v1s5tkr454">
              {index + 1} / {total}
            </p>

            <ul className="mt-5 flex flex-wrap gap-2.5" data-id="element-151" data-mp="1q5jrxv3a4tmw">
              {pageSamples.map((page, pageIndex) => <li key={page.src} data-id="element-152" data-mp="31imagvoxvt9p" data-mpi={pageIndex}>
                  <button type="button" onClick={() => go(pageIndex)} aria-label={`Przejdź do: ${page.title}`} aria-current={pageIndex === index} className={`h-16 w-12 overflow-hidden rounded-lg border-2 bg-white transition-colors duration-150 ease-out focus:outline-none focus-visible:ring-4 focus-visible:ring-brand/30 sm:h-20 sm:w-16 ${pageIndex === index ? 'border-brand' : 'border-ink/10 hover:border-ink/30'}`} data-id="element-153" data-mp="31haxq6dinb6g">
                    <img src={page.src} alt="" className="h-full w-full object-cover object-top" data-id="element-154" data-mp="1aze5by9m1l0t" />
                  </button>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}